module.exports = __webpack_public_path__ + "img/profitAndLoss-md.05861ae8.svg";